export const CHECKOUT_URL = "https://articulation-en.impultienda.ar/checkout/";
export const PRODUCT_NAME = "Pediatric Articulation Clinical Blueprint™";
export const MOCKUP_URL =
  "https://cdn.magicpatterns.com/uploads/jRVr8vgGoNqKN9SoFLaAEN/MOCKUP_ARTICULATION-EN.png";
export const AUTHOR_PHOTO_URL =
  "https://cdn.magicpatterns.com/uploads/fbkiWMMZ8W8eqHdzx4o66w/Dr._Elena_Martins_-_AAC.png";
export const SPOTS_LEFT = 7;
export const SPOTS_CLAIMED_PERCENT = 94;
export const COUNTDOWN_SECONDS = 17 * 60 + 34;
